import { HEX_COLOR_REGEX } from '../constants/hexColorRegex'

export const isValidHexColor = (value: string): boolean => {
  return HEX_COLOR_REGEX.test(value)
}
